"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextPowerOf2 = exports.mod = exports.roundToEven = exports.roundDecimals = exports.clamp = exports.epsilon = exports.decimalPrecision = void 0;
exports.decimalPrecision = 6;
exports.epsilon = 1 / 10 ** exports.decimalPrecision;
function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}
exports.clamp = clamp;
function roundDecimals(num, precision = exports.decimalPrecision) {
    const v = 10 ** precision;
    return Math.round(num * v) / v;
}
exports.roundDecimals = roundDecimals;
function roundToEven(num) {
    return Math.round(num / 2.0) * 2.0;
}
exports.roundToEven = roundToEven;
function mod(num, divisor) {
    return ((num % divisor) + divisor) % divisor;
}
exports.mod = mod;
function nextPowerOf2(num) {
    return Math.pow(2, Math.ceil(Math.log(num) / Math.log(2)));
}
exports.nextPowerOf2 = nextPowerOf2;
